<div class="action-wrapper">
  @if (canView) {
    <button class="action-wrapper__icon-button" matTooltip="View" (click)="onViewAction()">
      <img class="icon" src="assets/images/btn_view_active.svg" />
    </button>
  }
  @if (canEdit) {
    <button class="action-wrapper__icon-button" matTooltip="Edit" (click)="onEditAction()">
      <img class="icon" src="assets/images/btn_edit_action.svg" />
    </button>
  }
  @if (canDelete) {
    <button class="action-wrapper__icon-button" matTooltip="Delete" (click)="onDeleteAction()">
      <img class="icon" src="assets/images/btn_delete_action.svg" />
    </button>
  }
  @if (canInitiateProject) {
    <button class="action-wrapper__icon-button" (click)="initiateProject()">
      <mat-icon>slideshow</mat-icon>
    </button>
  }

  @if (canAssignCoordinator) {
    <button class="action-wrapper__icon-button" matTooltip="Assign User" (click)="assignCoordinator()">
      <img src="/assets/images/person_add.svg" />
    </button>
  }

  @if (canViewLogs) {
    <button class="action-wrapper__icon-button history-icon" matTooltip="View Logs" (click)="viewLogs()">
      <mat-icon>history</mat-icon>
    </button>
  }

  <!-- && userRole==='super-admin' -->
  @if (canViewSettings && (userRole==='Super-Admin' || userRole==='Admin')) {
    <button class="action-wrapper__icon-button" matTooltip="View Settings" (click)="onViewSettings()">
      <img class="icon" src="assets/images/settings.svg" />
    </button>
  }
</div>

<mat-drawer #drawer class="activity-log" mode="side" position="end">
  <button mat-button (click)="closeLogs()" class="activity-btn">
    Close
  </button>

  <p class="head">Activity History</p>
  @if (isLogsOpened) {
    <app-view-activity-logs [projectData]="rowData.project_code"></app-view-activity-logs>
  }
</mat-drawer>